import { render, staticRenderFns } from "./Resign.vue?vue&type=template&id=8f900b32&scoped=true"
import script from "./Resign.vue?vue&type=script&lang=js"
export * from "./Resign.vue?vue&type=script&lang=js"
import style0 from "./Resign.vue?vue&type=style&index=0&id=8f900b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f900b32",
  null
  
)

export default component.exports